angular.module('iqxCore')
.controller('OwnerSearchContactsCtrl', function ($scope, FormSvc, actionDialogSvc, $routeParams, ApiSvc) {
	$scope.checkPermissions('OWNER')

	$scope.getFilters=function(){
		return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetOwnerCompanySelect',fetchTarget:'filters',multiRow:true})
		.then(function(){
			$scope.SearchFilter=$scope.filters[0]
		})
	}

	$scope.search=function(searchTerm, SearchFilter){
		$scope.searchTerm=searchTerm
		$scope.searchFilter=SearchFilter.value
	    FormSvc.setOptions($scope,{
	      fetchAPI:'callresult/NetOwnerContactSearch?SearchValue='+encodeURIComponent($scope.searchTerm)+'&SearchState='+encodeURIComponent($scope.searchFilter),
		  multiRow:true,
		  sliceSize:10
	    })
	    $scope.fetch()
	    .then(function(){
	    	if ($scope.theRecords.length == '1' && $scope.theRecords[0]['Name'] == '') {
	    		$scope.theRecords=[]
	    	}
	    })
	}

	$scope.showActionDialog=function(obj){
    	let theObj={
    	  linkID:obj.EmploymentID, // Contains the ID of the person, vacancy, client etc...
    	  type:"Contact" // Person, Vacancy, Client etc...
    	}
		actionDialogSvc.show($scope, theObj)
	}

	if ($routeParams.searchTerm) {
		$scope.SearchValue=$routeParams.searchTerm
		$scope.search($routeParams.searchTerm, '')
	}

	$scope.getFilters()
})
